module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clifford A. Pickover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Clifford A. Pickover, a research staff member at IBM’s T. J. Watson Research Center, is an authority on the interface of science, art, mathematics, computing, and the visual modeling of data. He is the author of such highly regarded books as "), _c('I', [_vm._v("Black Holes: A Traveler’s Guide")]), _vm._v(", "), _c('I', [_vm._v("The Alien IQ Test")]), _vm._v(", and "), _c('I', [_vm._v("Chaos in Wonderland: Visual Adventures in a Fractal World")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15LjGtK/tc-custom/9781402790997.jpg?1712387812872",
      "alt": "This image is the cover for the book Physics Book, Union Square & Co. Milestones"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Physics Book, Union Square & Co. Milestones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A thrilling, fast-paced excursion through the history of physical discovery . . . from silly putty to string theory” (Dr. Paul Halpern, author of "), _c('i', [_vm._v("Collider")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Following his previous volumes, "), _c('i', [_vm._v("The Science Book")]), _vm._v(" and "), _c('i', [_vm._v("The Math Book")]), _vm._v(", acclaimed science writer Clifford Pickover returns with a richly illustrated chronology of physics, containing 250 short, entertaining, and thought-provoking entries. In addition to exploring such engaging topics as dark energy, parallel universes, the Doppler effect, the God particle, and Maxwells demon, "), _c('i', [_vm._v("The Physics Book")]), _vm._v(" extends back billions of years to the hypothetical Big Bang and forward trillions of years to a time of “quantum resurrection.” Like the previous titles in this series, "), _c('i', [_vm._v("The Physics Book")]), _vm._v(" offers a lively and accessible account of major concepts without getting bogged down in complex details.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sterling Publishing Co., Inc\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0